





















































import { Vue, Component } from 'vue-property-decorator';
import AlterationReports from "@/modules/budget/alteration/form/tabs/AlterationReports.vue";
import RefForm from "@/modules/budget/alteration/RefForm.vue";
import ApplForm from "@/modules/budget/alteration/ApplForm.vue";
import AlterationFlk from "@/modules/budget/alteration/AlterationFlk.vue";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import Journal from "@/modules/budget/alteration/Journal.vue";

@Component({
    components: { RefForm, ApplForm, AlterationReports, AlterationFlk, Journal }
})
export default class AlterationForm extends AlterationI18nMixin {
    private requestTypeOptions = [];
    private regionBase = [];
    public yearList: any = [];
    public applicationsItem = {};
    public applicationsItems = {};
    public indexTab = 0;
    public accessLevelsSettings = {
        editAccess: true,
        position: undefined,
        operations: []
    };
    public accessModules = [];
    private reLoadChild = false;
    public journalKey = 0
    public isLoadToJournalEnabled = true

    private get userId(): [] {
        return this.$store.getters.user_uuid;
    }
    public async loadRegions() {
        let listReg = null;
        try {
            const response = await fetch(
                `/api/budget-programs/budget_request_bp/budget_regions?user_uuid=${this.userId}`
            );
            // const response = await fetch('/api-py/get-user-regions-by-uuid/' + this.userId);
            listReg = await response.json();
            this.regionBase = listReg
                .sort((a: any, b: any) => parseInt(a.code) - parseInt(b.code))
            this.nameLocale(this.regionBase);
        } catch (error) {
            this.makeToast("danger", this.getTitle('errors.region'), error.toString());
        }
    }
    // Индексы вкладок здесь не задаём: индекс в b-tabs зависит от того, какие вкладки доступны
    // пользователю. Нужную вкладку активируют ApplForm/RefForm по ref на самой вкладке.
    private applsABPActive(currentAlteration: {}) {
        // «Заявки АБП» — ApplForm (watch applicationsItem)
        this.applicationsItems = currentAlteration;
    }
    private reqABPActive(currentAlteration: {}) {
        // «Справки (расходы)» — ApplForm.applicationsABPActive
        this.applicationsItem = currentAlteration;
    }
    private refsABPActive(currentAlteration: {}) {
        // «Справки АБП» — RefForm (watch applicationsItem, индивидуальная заявка)
        this.applicationsItem = currentAlteration;
    }
    private onReLoadC(val: boolean) {
        this.reLoadChild = val;
    }
    private onUnReLoad(val: boolean) {
        this.reLoadChild = val;
    }
    public async loadYears() {
        const yearNow = new Date().getFullYear();
        for (let i = yearNow; i >= yearNow - 10; i--) {
            if (i >= 2020) {
                this.yearList.push(i);
            }
        }
    }
   // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    public created() {
        this.indexTab = 0;
    }
    private async mounted()  {
        this.accessLevelsSettings = await this.getAccess('005.002.010', this.userId);
        this.accessModules = await this.getAccessModules('005.002.', this.userId);
        await this.loadRegions();
        await this.loadYears();
        await this.loadRequestTypes();
        this.indexTab = 0;
    }
    private getTitle(field: string): any {
        const mainTextFieldName = "modules.budget_execution_alteration." + field;
        return this.$t(mainTextFieldName);
    }
    private async loadRequestTypes () {
        try {
            const response = await fetch(
                `/api-py/get-request-type`
            );
            this.requestTypeOptions  = await response.json();
        } catch (error) {
        }
    }
}
